/**
 * Канонические статусы заказа. Они общие для всех магазинов: адаптер каждого
 * магазина отображает свои значения сюда и обратно. Значения стабильны —
 * в UI и в событиях опираться нужно на них, а не на подписи.
 */
export const ORDER_STATUSES = [
    'pending',
    'processing',
    'on_hold',
    'shipped',
    'awaiting_pickup',
    'completed',
    'cancelled',
    'refunded',
    'failed',
];
export function isOrderStatus(value) {
    return typeof value === 'string' && ORDER_STATUSES.includes(value);
}
/** Группы для вкладок: в одной вкладке — статусы, с которыми работают вместе. */
export const ORDER_STATUS_GROUPS = {
    active: ['pending', 'processing', 'on_hold'],
    shipping: ['shipped', 'awaiting_pickup'],
    done: ['completed'],
    problem: ['cancelled', 'refunded', 'failed'],
};
export const PAYMENT_METHODS = ['cod', 'card', 'crypto', 'bank', 'cash', 'other'];
export const PAYMENT_STATUSES = [
    'unpaid',
    'pending',
    'partial',
    'paid',
    'failed',
    'refunded',
];
export const DELIVERY_METHODS = ['novaposhta', 'meest', 'courier', 'pickup', 'other'];
export function orderRef(storeId, id) {
    return `${storeId}:${id}`;
}
export function parseOrderRef(ref) {
    const at = ref.indexOf(':');
    if (at <= 0 || at === ref.length - 1)
        return null;
    return { storeId: ref.slice(0, at), id: ref.slice(at + 1) };
}
//# sourceMappingURL=order.js.map